import {
  ComponentVariant,
  ComponentSize,
} from 'src/modules/shared/types/component.type';
import { classes } from 'src/modules/shared/utils/styles.util';

interface AnimatedDotProps {
  variant?: ComponentVariant;
  size?: ComponentSize;
  className?: string;
  isPulsing?: boolean;
}

export const AnimatedDot = ({
  variant = 'success',
  size = 'md',
  className,
  isPulsing = true,
}: AnimatedDotProps) => {
  const variantClasses: Record<ComponentVariant, string> = {
    primary: 'bg-primary-500',
    secondary: 'bg-secondary-500',
    neutral: 'bg-neutral-500',
    danger: 'bg-danger-500',
    warning: 'bg-warning-500',
    success: 'bg-success-500',
    info: 'bg-info-500',
    whatsapp: 'bg-whatsapp-500',
    call: 'bg-call-500',
    email: 'bg-email-500',
  };

  const sizeClasses: Record<ComponentSize, string> = {
    '2xs': 'w-1 h-1',
    xs: 'w-1.5 h-1.5',
    sm: 'w-2 h-2',
    md: 'w-2.5 h-2.5',
    lg: 'w-3 h-3',
  };

  return (
    <div
      className={classes(
        'rounded-full',
        isPulsing && 'animate-pulse',
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
    />
  );
};
